"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerState = void 0;
const enums_1 = require("../enums");
function getCustomerState() {
    const loggedinEmailsha256salt = window?.Evelin?.data?.julien?.hashedCustomerEmail;
    return {
        loggedin: loggedinEmailsha256salt ? enums_1.LoggedInState.YES : enums_1.LoggedInState.NO,
        loggedinEmailsha256salt,
    };
}
exports.getCustomerState = getCustomerState;
//# sourceMappingURL=getCustomerState.js.map